import { StatusCodes } from "http-status-codes";
import request from "../infra/request";
import { getUserActivityInfoFromStorage } from "../utils/userActivity";
import { getCachedIdToken } from "../utils/idTokenCache";

const { CREATED, OK } = StatusCodes;

export const checkInUser = async () => {
  try {
    const { data, status } = await request.post(`${process.env.REACT_APP_USER_ACTIVITIES}/check-in`, {});

    if (status === CREATED) {
      return data;
    }

    return { error: new Error(`Can not record user's activity`) };
  } catch (error) {
    return { error };
  }
};

export const checkoutUser = async (userActivityId) => {
  try {
    const activityId = userActivityId || "";
    const { status } = await request.post(`${process.env.REACT_APP_USER_ACTIVITIES}/check-out/${activityId}`, {});

    if (status !== CREATED) {
      return { error: new Error("Can not add user logout time to server.") };
    }
  } catch (error) {
    return { error };
  }
};

export const getUserActivityReport = async ({ startDate, endDate }) => {
  try {
    const { status, data } = await request.get(`${process.env.REACT_APP_USER_ACTIVITIES}/report`, {
      params: { startDate, endDate },
      responseType: "blob",
    });

    if (status === OK) {
      return { data };
    }
    return { error: new Error("Can not get report of user activity") };
  } catch (error) {
    return { error };
  }
};

export const checkIsLoginStatusExpired = async (userActivityId) => {
  try {
    const { status, data } = await request.get(
      `${process.env.REACT_APP_USER_ACTIVITIES}/login-status/${userActivityId}`
    );

    if (status === OK) {
      return { data };
    }
    return { error: new Error("Can not check user status") };
  } catch (error) {
    return { error };
  }
};

export const sendHeartbeat = async (userActivityId) => {
  if (!userActivityId) return { error: new Error("User activity id is required") };

  try {
    const { status, data } = await request.post(
      `${process.env.REACT_APP_USER_ACTIVITIES}/heartbeat/${userActivityId}`,
      {}
    );

    // `isExpired` says the session this tab was keeping alive is already gone.
    if (status === OK) {
      return { data };
    }
    return { error: new Error("Can not record user heartbeat.") };
  } catch (error) {
    return { error };
  }
};

// Must stay synchronous: it runs while the page is unloading, and anything
// awaited before the request is dispatched (such as `getIdToken()`) is simply
// never sent. The token comes from the cache kept by `initIdTokenCache`.
export const logCloseTabEvent = () => {
  const { userActivityId, userActivitySessionId } = getUserActivityInfoFromStorage();
  const userIdToken = getCachedIdToken();

  if (!userIdToken || !userActivityId || !userActivitySessionId) return;

  fetch(`${process.env.REACT_APP_USER_ACTIVITIES}/close-tab`, {
    keepalive: true,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userIdToken}`,
    },
    body: JSON.stringify({ userActivityId, userActivitySessionId }),
  }).catch(() => {});
};
